export const Logo = ({className}: {className: string}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M48 100C25.3726 100 14.0589 100 7.02944 92.9705C-6.23472e-07 85.9411 -1.12521e-06 74.6273 -2.12867e-06 51.9998L-2.30607e-06 47.9997C-3.30953e-06 25.3722 -3.81127e-06 14.0585 7.02944 7.02904C14.0589 1.46531e-05 25.3726 1.41656e-05 47.9999 1.31907e-05L48 1.31907e-05L52 1.30184e-05L52.0001 1.30184e-05C74.6274 1.20435e-05 85.9411 1.1556e-05 92.9706 7.02904C100 14.0585 100 25.3722 100 47.9997L100 51.9997C100 74.6273 100 85.9411 92.9706 92.9705C85.9411 100 74.6274 100 52 100L48 100Z"
        fill="#2B71F6"
      />
      <path
        d="M57.8261 61.6261C55.1318 60.953 53.2427 58.5429 53.2427 55.7787L53.2427 23.213C53.2427 20.0733 56.2095 17.7706 59.2697 18.5351L78.6493 23.3762C81.3436 24.0492 83.2327 26.4593 83.2327 29.2235L83.2327 61.7893C83.2327 64.929 80.2659 67.2317 77.2057 66.4672L57.8261 61.6261Z"
        fill="white"
      />
      <path
        d="M21.3505 76.6223C18.6562 75.9493 16.7671 73.5392 16.7671 70.775L16.7671 38.2092C16.7671 35.0695 19.7339 32.7669 22.7941 33.5313L42.1737 38.3724C44.868 39.0455 46.7571 41.4556 46.7571 44.2198L46.7571 76.7856C46.7571 79.9252 43.7903 82.2279 40.7301 81.4634L21.3505 76.6223Z"
        fill="white"
      />
      <path
        d="M39.5888 69.1243C36.8945 68.4512 35.0054 66.0411 35.0054 63.2769L35.0054 30.7112C35.0054 27.5715 37.9722 25.2688 41.0324 26.0333L60.412 30.8744C63.1063 31.5474 64.9954 33.9575 64.9954 36.7218L64.9954 69.2875C64.9954 72.4272 62.0286 74.7299 58.9684 73.9654L39.5888 69.1243Z"
        fill="white"
      />
      <path
        d="M52.2724 72.3017C51.4238 72.0856 50.8198 71.3351 50.7901 70.4599L49.947 45.5896C49.7031 42.298 47.2598 39.6802 44.7064 38.9092C44.5631 38.8659 44.41 38.9242 44.3251 39.0476C44.2388 39.1729 44.2721 39.3464 44.3925 39.4396C45.023 39.9276 46.7584 41.5205 46.7584 44.2678L46.7532 70.9031L52.2724 72.3017Z"
        fill="#2B71F6"
      />
      <path
        d="M70.5142 64.797C69.6663 64.5848 69.0616 63.8366 69.0319 62.963L68.1887 38.0945C67.9448 34.8029 65.5015 32.185 62.9481 31.4141C62.8048 31.3708 62.6517 31.4291 62.5668 31.5524C62.4805 31.6778 62.5138 31.8513 62.6342 31.9445C63.2647 32.4325 65.0001 34.0253 65.0001 36.7727L64.995 63.4171L70.5142 64.797Z"
        fill="#2B71F6"
      />
    </svg>
  );
};
